import { TripLegProviderCallOutcome } from './reservation.model';

export interface Provider {
  transportationProviderID: number;
  transportationProviderName: string;
  isClearToTransport: boolean;
  rideshare?: {
    transportationProviderID: number;
  };
  transportationProviderCoverageAreas: {
    transportationProviderCoverageAreaID: number;
    coverageArea: { coverageAreaID: number; coverageAreaName: string };
  }[];
  phoneNumbers?: ProviderPhoneContact[];
  ownerFirstName?: string;
  ownerLastName?: string;
  transportationProviderPhones?: ProviderPhoneContact[];
  transportationProviderTierBC?: TransportationProviderTierBC;
  callOutcomeID?: number;
  callOutcomeRejectReasonID?: number;
  callOutcomeName?: string;
  callOutcomeRejectReasonName?: string;
  outcomeTransportationProviderID?: number;
  outcomeCreatedOnUTC?: string;
  tripLegProviderCallOutcomes?: TripLegProviderCallOutcome[];
}

export enum TransportationProviderTierBC {
  Tier1 = 'TIER1',
  Tier2 = 'TIER2',
  Tier3 = 'TIER3',
}

export enum TransportationProviderTier {
  Tier1 = '1',
  Tier2 = '2',
  Tier3 = '3',
}

export interface CoverageArea {
  coverageAreaID: number;
  coverageAreaName: string;
  effectiveStartDate: string;
  effectiveEndDate: string;
  boundaryTypeID: number;
  coverageAreaState: string;
}

export interface ProviderPhoneContact {
  transportationProviderID: number;
  transportationProviderPhoneID: number;
  transportationProviderPhoneUseID: number;
  transportationProviderPhoneState: string;
  phoneNumberTypeID: number;
  phoneNumber: string;
  phoneExtension: string;
  contactFirstName: string;
  contactLastName: string;
  hasSMSConsent: boolean;
  isPrimaryPhoneNumber: boolean;
}
